<template>
  <v-container>
    <div>
      <v-row justify="start">
        <v-col cols="12" sm="3">
          <vc-date-picker mode="range" v-model="dateRange" :popover="{label: 'Hover', visibility: 'hover'}">
          </vc-date-picker>
        </v-col>

        <v-col cols="12" sm="2" justify="end">
          <v-btn color="primary" dark @click="getData">{{ $t('common.search') }}</v-btn>
        </v-col>

        <v-col cols="12" sm="7">
          <div class="d-flex flex-row-reverse">
            <v-btn color="primary" dark @click="getData" class="ml-5">{{ $t('common.refresh') }}</v-btn>

            <download-excel
                class="btn btn-default"
                :data="selectedRows"
                :fields="json_fields"
                worksheet="My Worksheet"
                name="logistics.xls"
            >
              <v-btn color="primary" dark>{{ 'Download' }}</v-btn>
            </download-excel>


          </div>
        </v-col>
      </v-row>
    </div>

    <v-data-table v-model="selectedRows" :headers="headers" :items="desserts" :search="search" sort-by="date" :loading="loading"
                  class="elevation-1" hide-default-footer :page.sync="page" :items-per-page="itemsPerPage"
                  @page-count="pageCount = $event" show-select item-key="code" :item-class="this.$statusShip">
      <template v-slot:top>
        <v-toolbar flat color="white" class="pt-5">
          <v-row justify="start">
            <v-col cols="12" sm="2">
              <span>Tổng số: <span class="summaryFont"> {{ totalManufactureRequest }} </span> </span>
            </v-col>

            <v-col cols="12" sm="1">
              <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined :dense="true"></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectedLogisticStatus" :items="logisticStatus" item-text="title" outlined
                              :dense="true" return-object></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectReadStatus" :items="readStatus" item-text="title" outlined :dense="true" return-object></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-autocomplete v-model="selectedLogisticUnitFilter" :items="logisticUnitsFilter" item-text="name" outlined
                              :dense="true" return-object></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3">
              <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line
                            hide-details outlined :dense="true"></v-text-field>
            </v-col>
          </v-row>
        </v-toolbar>
      </template>

      <template v-slot:[`item.logisticUnit`]="{ item }">
        <div class="contentAddress">
          <span class="text-no-wrap"> {{ item.logisticUnit ? item.logisticUnit.name : 'Chưa gán' }} </span>
        </div>
      </template>

      <template v-slot:[`item.logisticStatus`]="{ item }">
        <span class="text-no-wrap"> {{ getTextByStatus(item) }} </span>
      </template>


      <template v-slot:[`item.deadline`]="{ item }">
        <span class="text-no-wrap">{{ item.deadline | formateDate }}</span>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <div class="contentTitle">
          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small class="mr-2" @click="showEditShipRequestDialog(item)">
                edit
              </v-icon>
            </template>
            <span>Chỉnh sửa thông tin</span>
          </v-tooltip>

          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small class="mr-2" @click="showDetail(item)">
                info
              </v-icon>
            </template>
            <span>Thông tin chi tiết</span>
          </v-tooltip>

          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small class="mr-2" @click="exportToPDF(item)">
                print
              </v-icon>
            </template>
            <span>Export ra file PDF</span>
          </v-tooltip>

          <v-tooltip slot="append-outer" bottom max-width="300px" color="primary">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" small class="mr-2" @click="showShipCodeDialog(item)" v-show="item.logisticStatus > 1">
                local_shipping
              </v-icon>
            </template>
            <span>Nhập mã đơn vận</span>
          </v-tooltip>
        </div>
      </template>

      <template v-slot:[`item.forward`]="{ item }">
        <v-btn v-if="item.logisticStatus === 0" disabled>
          {{ $t('logistic_request.assign_logistic') }}
        </v-btn>

        <v-btn v-else-if="item.logisticStatus === 1" color="primary" dark @click="showChosenLogisticDialog(item)">
          {{ $t('logistic_request.assign_logistic') }}
        </v-btn>

        <v-btn v-else color="primary" dark @click="showConfirmStatus(item)">
          {{ $t('logistic_request.confirm') }}
        </v-btn>
      </template>

      <template v-slot:[`item.designRequest.requestTitle`]="{ item }">
                <span class="contentTitle">
<!--                    {{ item.designRequest.requestTitle + (item.designRequest.orderUnit ? (' - ' + item.designRequest.orderUnit.name) : '') }}-->
                  {{ getManufactureTitle(item) }}
                </span>
      </template>

      <template v-slot:[`item.customer.fullname`]="{ item }">
                <span class="contentName">
                    {{ item.customer.fullname }}
                </span>
      </template>

      <template v-slot:no-data>
        <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>

    <manufacture-request-dialog v-model="dialogDetail" :editedItem="editedItem" :editable="false"
                                @closeDialog="closeDetail"
                                v-if="editedItem">
    </manufacture-request-dialog>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-dialog v-model="chosenLogisticDialog" max-width="60%">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('logistic_request.chosen_logistic_unit') }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-autocomplete v-model="selectedLogisticUnit" :items="logisticUnits" item-text="name" outlined
                              :dense="true" return-object></v-autocomplete>
            </v-row>
          </v-container>

          <v-divider></v-divider>
          <v-toolbar flat>
            <v-btn color="primary" width="120px" @click="closeSelectLogisticUnit()">{{ $t('common.cancel') }}</v-btn>

            <v-spacer></v-spacer>

            <v-btn color="primary" @click="assignLogisticUnit()" width="120px" class="mr-5">
              {{ $t('common.ok') }}
            </v-btn>
          </v-toolbar>
        </v-card-text>
      </v-card>

      <v-overlay :value="overlay" :z-index="0">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>

    <v-dialog v-model="confirmDialoag" max-width="60%">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('logistic_request.confirm_dialog') }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-autocomplete v-model="selectedConfirmLogisticStatus" :items="confirmLogisticStatus" item-text="title"
                              outlined :dense="true" return-object></v-autocomplete>
            </v-row>
          </v-container>

          <v-divider></v-divider>
          <v-toolbar flat>
            <v-btn color="primary" width="120px" @click="closeConfirmStatus()">{{ $t('common.cancel') }}</v-btn>

            <v-spacer></v-spacer>

            <v-btn color="primary" @click="confirmStatus()" width="120px" class="mr-5">
              {{ $t('common.ok') }}
            </v-btn>
          </v-toolbar>
        </v-card-text>
      </v-card>

      <v-overlay :value="overlay" :z-index="0">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>

    <v-dialog v-model="shipCodeDialog" max-width="60%">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('logistic_request.ship_code_dialog') }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-text-field v-model="shipCode" v-bind:label="$t('logistic_request.ship_code')" outlined dense>
              </v-text-field>
            </v-row>
          </v-container>

          <v-divider></v-divider>
          <v-toolbar flat>
            <v-btn color="primary" width="120px" @click="closeShipCodeDialog()">{{ $t('common.cancel') }}</v-btn>

            <v-spacer></v-spacer>

            <v-btn color="primary" @click="saveShipCodeDialog()" width="120px" class="mr-5">
              {{ $t('common.ok') }}
            </v-btn>
          </v-toolbar>
        </v-card-text>
      </v-card>

      <v-overlay :value="overlay" :z-index="0">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>

    <edit-ship-request-dialog v-model="shipRequestDialog" :editedItem="editedItem" @closeDialog="closeShipRequest"
                              @update="updateManufactureItem" v-if="editedItem"></edit-ship-request-dialog>
  </v-container>
</template>

<script>
import i18n from '@/plugins/i18n';
import moment from 'moment';
import ManufactureRequestDialog from "@/components/ManufactureRequestDialog";
import EditShipRequestDialog from "@/components/EditShipRequestDialog";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import socketClient from "@/plugins/socketClient";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  data: () => ({
    baseImage: process.env.VUE_APP_BASE_IMAGE,
    baseAttach: process.env.VUE_APP_BASE_ATTACH,

    dateRange: {start: new Date(new Date().setDate(new Date().getDate() - 7)), end: new Date()},
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    overlay: false,
    isSearching: false,
    selectedLogisticUnit: {},
    selectedLogisticUnitFilter: {},
    chosenLogisticDialog: false,

    shipCodeDialog: false,
    shipCode: '',

    shipRequestDialog: false,

    logisticUnits: [],
    logisticUnitsFilter: [{
      name: 'Tất cả',
      _id: -1
    }],
    loading: true,
    numberPage: [
      5, 10, 15, 20, 25
    ],

    selectReadStatus: {title: i18n.t('common.all'), value: -1},
    readStatus: [
      {title: i18n.t('common.unread'), value: 0},
      {title: i18n.t('common.read'), value: 1},
      {title: i18n.t('common.all'), value: -1}
    ],

    selectedLogisticStatus: {title: i18n.t('logistic_request.request'), value: 1},
    logisticStatus: [
      {title: i18n.t('logistic_request.all'), value: -1},
      {title: i18n.t('logistic_request.not_request'), value: 0},
      {title: i18n.t('logistic_request.request'), value: 1},
      {title: i18n.t('logistic_request.requesting'), value: 2},
      {title: i18n.t('logistic_request.finish'), value: 3},
      {title: i18n.t('logistic_request.request_again'), value: 4},
      {title: i18n.t('logistic_request.fail'), value: 5}
    ],

    selectedConfirmLogisticStatus: {title: i18n.t('logistic_request.finish'), value: 3},
    confirmLogisticStatus: [
      {title: i18n.t('logistic_request.finish'), value: 3},
      {title: i18n.t('logistic_request.request_again'), value: 4},
      {title: i18n.t('logistic_request.fail'), value: 5}
    ],
    confirmDialoag: false,

    selectedManufactureRequest: {},
    search: '',
    dialog: false,
    dialogDetail: false,
    designRequest: {},

    totalManufactureRequest: 0,

    headers: [
      {text: '#', align: 'left', sortable: false, value: 'index',},
      {text: i18n.t('design_manager.code_manufacture'), sortable: false, value: 'code'},
      {text: i18n.t('design_manager.code'), sortable: false, value: 'designRequest.code'},
      {text: i18n.t('design_manager.name'), sortable: false, value: 'designRequest.requestTitle'},
      {text: i18n.t('design_manager.customer'), sortable: false, value: 'customer.fullname'},
      {text: i18n.t('logistic_request.deadline'), value: 'deadline'},

      {text: i18n.t('logistic_request.logistic_unit'), sortable: false, value: 'logisticUnit'},
      {text: '', sortable: false, value: 'logisticUnit.name', align: ' d-none'},

      {text: i18n.t('manufacture_manager.status'), value: 'logisticStatus', sortable: false},
      {text: i18n.t('design_manager.infor'), align: 'center', sortable: false, value: 'action'},
      {text: '', align: 'center', sortable: false, value: 'forward'}
    ],
    desserts: [],
    fullRequests: [],
    editedIndex: -1,
    editedItem: null,

    stringRules: [
      v => !!v || i18n.t('validate.not_empty'),
      v => (v && v.length > 5) || i18n.t('validate.string_invalid')],

    json_fields: {
      "Ngày hoàn thành SX": {
        field: "deadline",
        callback: (value) => {
          return moment(String(value)).format("DD/MM/YYYY");
        }
      },
      "Ngày khách nhận": {
        field: "receiveDate",
        callback: (value) => {
          return moment(String(value)).format("DD/MM/YYYY");
        }
      },
      "Ngày COD lấy": "cod",
      "Thời gian giao hàng": "receiveTime",
      "Mã đơn vận": "shipCode",
      "Trạng thái": {
        field: "logisticStatus",
        callback: (value) => {
          if (value === 0) {
            return i18n.t('logistic_request.not_request');
          } else if (value === 1) {
            return i18n.t('logistic_request.request');
          } else if (value === 2) {
            return i18n.t('logistic_request.requesting');
          } else if (value === 3) {
            return i18n.t('logistic_request.finish');
          } else if (value === 4) {
            return i18n.t('logistic_request.request_again');
          } else if (value === 5) {
            return i18n.t('logistic_request.fail');
          }
        }
      },
      "Mã Sale": "sale.nickname",
      "Mã YCSX": "code",
      "Số lượng": "numberOfProductReceived",
      "Người nhận": "customer.defaultAddress.name",
      "SĐT": "customer.defaultAddress.phone",
      "Địa chỉ": "customer.defaultAddress.fullDetail",
      "Tiền COD": "totalEdit",
      "Nội dung": "content",
      "Trọng lượng": "weight",
      "Ghi chú": "shipNote",
      "Phí ship": "shipFee",
      "": "nothing",
      "Trả đổi soát": "changer"
    },
    selectedRows: [],
  }),

  computed: {},

  components: {
    ManufactureRequestDialog: ManufactureRequestDialog,
    EditShipRequestDialog: EditShipRequestDialog
  },

  watch: {
    selectedLogisticStatus() {
      this.filterData();
    },

    selectReadStatus() {
      this.filterData();
    },

    selectedLogisticUnitFilter() {
      this.filterData();
    }
  },

  created() {
    this.getData();
    this.getLogisticUnit();
    this.isSearching = true;

    const self = this;
    socketClient.getIO().on('CREATE_SHIP_REQUEST', () => {
      self.getData();
    });

    socketClient.getIO().on('UPDATE_SHIP_REQUEST', () => {
      self.getData();
    });
  },

  methods: {
    initialize() {
    },

    getManufactureTitle(item) {
      return this.$getManufactureTitle(item);
    },

    showEditShipRequestDialog(item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.shipRequestDialog = true;
    },

    closeShipRequest(value) {
      this.shipRequestDialog = value
      this.editedItem = null;
    },

    closeShipCodeDialog() {
      this.shipCodeDialog = false;
    },

    updateManufactureItem(value) {
      Object.assign(this.desserts[this.editedIndex], value);
    },

    showShipCodeDialog(item) {
      this.editedItem = Object.assign({}, item);
      this.editedIndex = this.desserts.indexOf(item);
      this.shipCode = this.editedItem.shipCode;
      this.shipCodeDialog = true;
    },

    async saveShipCodeDialog() {
      try {
        let requestBody = Object.assign({}, this.editedItem);
        requestBody = {
          ...requestBody,
          shipCode: this.shipCode,
          deadline: moment(String(this.editedItem.deadline)).format("DD/MM/YYYY"),
          receiveDate: moment(String(this.editedItem.receiveDate)).format("DD/MM/YYYY")
        }

        const response = await this.$http.put('/manufactureRequest/' + this.editedItem._id, requestBody);
        this.overlay = false;
        if (response.data && response.data.success) {
          this.$fire({
            title: i18n.t('common.update_success'),
            text: "",
            type: "success"
          }).then(() => {
            this.editedItem.shipCode = this.shipCode;
            Object.assign(this.desserts[this.editedIndex], this.editedItem);

            this.filterData();
            this.closeShipCodeDialog();
          });
        }
      } catch (e) {
        console.log(e.stack);
        this.overlay = false;
      }
    },

    closeDetail(value) {
      this.dialogDetail = value
      this.editedItem = null;
    },

    showDetail(item) {
      this.editedIndex = this.desserts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDetail = true;
    },

    getTextByStatus(item) {
      if (item.logisticStatus === 0) {
        return i18n.t('logistic_request.not_request');
      } else if (item.logisticStatus === 1) {
        return i18n.t('logistic_request.request');
      } else if (item.logisticStatus === 2) {
        return i18n.t('logistic_request.requesting');
      } else if (item.logisticStatus === 3) {
        return i18n.t('logistic_request.finish');
      } else if (item.logisticStatus === 4) {
        return i18n.t('logistic_request.request_again');
      } else if (item.logisticStatus === 5) {
        return i18n.t('logistic_request.fail');
      }
    },

    async getData() {
      this.overlay = this.isSearching;
      try {
        // const response = await this.$http.get('/designRequest');
        const from = moment(String(this.dateRange.start)).format("DD/MM/YYYY");
        const to = moment(String(this.dateRange.end)).format("DD/MM/YYYY");

        const response = await this.$http.get('/manufactureRequest/status/4?' + "from=" + from + "&to=" + to);
        this.overlay = false;

        this.loading = false;
        if (response.data && response.data.success) {
          // console.log(response.data);

          const contextArr = response.data.data;
          contextArr.forEach((item, index) => item.index = index + 1);
          this.desserts = contextArr;
          this.fullRequests = contextArr;
          this.totalManufactureRequest = this.desserts.length;

          this.filterData();
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    filterData() {
      if (!this.fullRequests || this.fullRequests.length == 0) {
        return;
      }

      if (this.selectedLogisticStatus.value === -1) {
        this.desserts = [].concat(this.fullRequests);
      } else {
        let dataArray = [];

        this.fullRequests.forEach(item => {
          if (item && item.logisticStatus === this.selectedLogisticStatus.value) {
            dataArray.push(item);
          }
        })

        this.desserts = [].concat(dataArray);
      }

      if (this.selectedLogisticUnitFilter._id !== -1) {
        this.desserts = [].concat(this.desserts.filter(function(item) {
          if (item.logisticUnit) {
            return this.selectedLogisticUnitFilter._id === item.logisticUnit._id;
          }
        }));
      }

      if (this.selectReadStatus.value !== -1) {
        this.desserts = [].concat(this.desserts.filter(item => item.shipReadStatus == this.selectReadStatus.value));
      }
    },

    async getLogisticUnit() {
      try {
        const response = await this.$http.get("/logisticUnit");
        if (response.data && response.data.success) {
          this.logisticUnits = [].concat(response.data.data);

          this.logisticUnitsFilter = this.logisticUnitsFilter.concat(this.logisticUnits);
          this.selectedLogisticUnitFilter = this.logisticUnitsFilter[0];
        } else if (response.data && !response.data.success) {
          alert(i18n.t(response.data.message));
        } else {
          alert(i18n.t('validate.request_error'));
        }
      } catch (e) {
        alert(i18n.t('validate.request_error'));
      }
    },

    showChosenLogisticDialog(item) {
      if (this.logisticUnits.length > 0) {
        this.selectedLogisticUnit = this.logisticUnits[0];
        this.chosenLogisticDialog = true;
        this.editedItem = item;
        this.editedIndex = this.desserts.indexOf(item)
      } else {
        alert(i18n.t('logistic_request.alert_empty'));
      }

    },

    closeSelectLogisticUnit() {
      this.chosenLogisticDialog = false;
      this.editedItem = null;
    },

    async assignLogisticUnit() {
      const requestBody = {
        logisticUnit: this.selectedLogisticUnit
      }

      try {
        const response = await this.$http.put('/manufactureRequest/' + this.editedItem._id + '/asignLogisticUnit', requestBody);
        if (response.data && response.data.success) {
          this.$fire({
            title: i18n.t('common.update_success'),
            text: "",
            type: "success"
          }).then(() => {
            this.editedItem.logisticStatus = 2;
            Object.assign(this.desserts[this.editedIndex], this.editedItem);
            this.editedItem = {};
            this.filterData();
            this.closeSelectLogisticUnit();
          });
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    showConfirmStatus(item) {
      this.selectedConfirmLogisticStatus = this.confirmLogisticStatus[0];
      this.confirmDialoag = true;
      this.editedItem = item;
      this.editedIndex = this.desserts.indexOf(item);
    },

    closeConfirmStatus() {
      this.confirmDialoag = false;
      this.editedItem = null;
    },

    async confirmStatus() {
      const requestBody = {
        logisticStatus: this.selectedConfirmLogisticStatus.value
      }

      try {
        const response = await this.$http.put('/manufactureRequest/' + this.editedItem._id + '/logisticStatus', requestBody);
        if (response.data && response.data.success) {
          this.$fire({
            title: i18n.t('common.update_success'),
            text: "",
            type: "success"
          }).then(() => {
            this.editedItem.logisticStatus = this.selectedConfirmLogisticStatus.value;
            Object.assign(this.desserts[this.editedIndex], this.editedItem);

            this.filterData();
            this.closeConfirmStatus();
          });
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    async exportToPDF(item) {
      var images = await this.generateImageContent(item);
      var content = [];
      var gauLogo = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAN8AAADfCAYAAAB2+QYsAAAACXBIWXMAAAsTAAALEwEAmpwYAAAKT2lDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVNnVFPpFj333vRCS4iAlEtvUhUIIFJCi4AUkSYqIQkQSoghodkVUcERRUUEG8igiAOOjoCMFVEsDIoK2AfkIaKOg6OIisr74Xuja9a89+bN/rXXPues852zzwfACAyWSDNRNYAMqUIeEeCDx8TG4eQuQIEKJHAAEAizZCFz/SMBAPh+PDwrIsAHvgABeNMLCADATZvAMByH/w/qQplcAYCEAcB0kThLCIAUAEB6jkKmAEBGAYCdmCZTAKAEAGDLY2LjAFAtAGAnf+bTAICd+Jl7AQBblCEVAaCRACATZYhEAGg7AKzPVopFAFgwABRmS8Q5ANgtADBJV2ZIALC3AMDOEAuyAAgMADBRiIUpAAR7AGDIIyN4AISZABRG8lc88SuuEOcqAAB4mbI8uSQ5RYFbCC1xB1dXLh4ozkkXKxQ2YQJhmkAuwnmZGTKBNA/g88wAAKCRFRHgg/P9eM4Ors7ONo62Dl8t6r8G/yJiYuP+5c+rcEAAAOF0ftH+LC+zGoA7BoBt/qIl7gRoXgugdfeLZrIPQLUAoOnaV/Nw+H48PEWhkLnZ2eXk5NhKxEJbYcpXff5nwl/AV/1s+X48/Pf14L7iJIEyXYFHBPjgwsz0TKUcz5IJhGLc5o9H/LcL//wd0yLESWK5WCoU41EScY5EmozzMqUiiUKSKcUl0v9k4t8s+wM+3zUAsGo+AXuRLahdYwP2SycQWHTA4vcAAPK7b8HUKAgDgGiD4c93/+8//UegJQCAZkmScQAAXkQkLlTKsz/HCAAARKCBKrBBG/TBGCzABhzBBdzBC/xgNoRCJMTCQhBCCmSAHHJgKayCQiiGzbAdKmAv1EAdNMBRaIaTcA4uwlW4Dj1wD/phCJ7BKLyBCQRByAgTYSHaiAFiilgjjggXmYX4IcFIBBKLJCDJiBRRIkuRNUgxUopUIFVIHfI9cgI5h1xGupE7yAAygvyGvEcxlIGyUT3UDLVDuag3GoRGogvQZHQxmo8WoJvQcrQaPYw2oefQq2gP2o8+Q8cwwOgYBzPEbDAuxsNCsTgsCZNjy7EirAyrxhqwVqwDu4n1Y8+xdwQSgUXACTYEd0IgYR5BSFhMWE7YSKggHCQ0EdoJNwkDhFHCJyKTqEu0JroR+cQYYjIxh1hILCPWEo8TLxB7iEPENyQSiUMyJ7mQAkmxpFTSEtJG0m5SI+ksqZs0SBojk8naZGuyBzmULCAryIXkneTD5DPkG+Qh8lsKnWJAcaT4U+IoUspqShnlEOU05QZlmDJBVaOaUt2ooVQRNY9aQq2htlKvUYeoEzR1mjnNgxZJS6WtopXTGmgXaPdpr+h0uhHdlR5Ol9BX0svpR+iX6AP0dwwNhhWDx4hnKBmbGAcYZxl3GK+YTKYZ04sZx1QwNzHrmOeZD5lvVVgqtip8FZHKCpVKlSaVGyovVKmqpqreqgtV81XLVI+pXlN9rkZVM1PjqQnUlqtVqp1Q61MbU2epO6iHqmeob1Q/pH5Z/YkGWcNMw09DpFGgsV/jvMYgC2MZs3gsIWsNq4Z1gTXEJrHN2Xx2KruY/R27iz2qqaE5QzNKM1ezUvOUZj8H45hx+Jx0TgnnKKeX836K3hTvKeIpG6Y0TLkxZVxrqpaXllirSKtRq0frvTau7aedpr1Fu1n7gQ5Bx0onXCdHZ4/OBZ3nU9lT3acKpxZNPTr1ri6qa6UbobtEd79up+6Ynr5egJ5Mb6feeb3n+hx9L/1U/W36p/VHDFgGswwkBtsMzhg8xTVxbzwdL8fb8VFDXcNAQ6VhlWGX4YSRudE8o9VGjUYPjGnGXOMk423GbcajJgYmISZLTepN7ppSTbmmKaY7TDtMx83MzaLN1pk1mz0x1zLnm+eb15vft2BaeFostqi2uGVJsuRaplnutrxuhVo5WaVYVVpds0atna0l1rutu6cRp7lOk06rntZnw7Dxtsm2qbcZsOXYBtuutm22fWFnYhdnt8Wuw+6TvZN9un2N/T0HDYfZDqsdWh1+c7RyFDpWOt6azpzuP33F9JbpL2dYzxDP2DPjthPLKcRpnVOb00dnF2e5c4PziIuJS4LLLpc+Lpsbxt3IveRKdPVxXeF60vWdm7Obwu2o26/uNu5p7ofcn8w0nymeWTNz0MPIQ+BR5dE/C5+VMGvfrH5PQ0+BZ7XnIy9jL5FXrdewt6V3qvdh7xc+9j5yn+M+4zw33jLeWV/MN8C3yLfLT8Nvnl+F30N/I/9k/3r/0QCngCUBZwOJgUGBWwL7+Hp8Ib+OPzrbZfay2e1BjKC5QRVBj4KtguXBrSFoyOyQrSH355jOkc5pDoVQfujW0Adh5mGLw34MJ4WHhVeGP45wiFga0TGXNXfR3ENz30T6RJZE3ptnMU85ry1KNSo+qi5qPNo3ujS6P8YuZlnM1VidWElsSxw5LiquNm5svt/87fOH4p3iC+N7F5gvyF1weaHOwvSFpxapLhIsOpZATIhOOJTwQRAqqBaMJfITdyWOCnnCHcJnIi/RNtGI2ENcKh5O8kgqTXqS7JG8NXkkxTOlLOW5hCepkLxMDUzdmzqeFpp2IG0yPTq9MYOSkZBxQqohTZO2Z+pn5mZ2y6xlhbL+xW6Lty8elQfJa7OQrAVZLQq2QqboVFoo1yoHsmdlV2a/zYnKOZarnivN7cyzytuQN5zvn//tEsIS4ZK2pYZLVy0dWOa9rGo5sjxxedsK4xUFK4ZWBqw8uIq2Km3VT6vtV5eufr0mek1rgV7ByoLBtQFr6wtVCuWFfevc1+1dT1gvWd+1YfqGnRs+FYmKrhTbF5cVf9go3HjlG4dvyr+Z3JS0qavEuWTPZtJm6ebeLZ5bDpaql+aXDm4N2dq0Dd9WtO319kXbL5fNKNu7g7ZDuaO/PLi8ZafJzs07P1SkVPRU+lQ27tLdtWHX+G7R7ht7vPY07NXbW7z3/T7JvttVAVVN1WbVZftJ+7P3P66Jqun4lvttXa1ObXHtxwPSA/0HIw6217nU1R3SPVRSj9Yr60cOxx++/p3vdy0NNg1VjZzG4iNwRHnk6fcJ3/ceDTradox7rOEH0x92HWcdL2pCmvKaRptTmvtbYlu6T8w+0dbq3nr8R9sfD5w0PFl5SvNUyWna6YLTk2fyz4ydlZ19fi753GDborZ752PO32oPb++6EHTh0kX/i+c7vDvOXPK4dPKy2+UTV7hXmq86X23qdOo8/pPTT8e7nLuarrlca7nuer21e2b36RueN87d9L158Rb/1tWeOT3dvfN6b/fF9/XfFt1+cif9zsu72Xcn7q28T7xf9EDtQdlD3YfVP1v+3Njv3H9qwHeg89HcR/cGhYPP/pH1jw9DBY+Zj8uGDYbrnjg+OTniP3L96fynQ89kzyaeF/6i/suuFxYvfvjV69fO0ZjRoZfyl5O/bXyl/erA6xmv28bCxh6+yXgzMV70VvvtwXfcdx3vo98PT+R8IH8o/2j5sfVT0Kf7kxmTk/8EA5jz/GMzLdsAAAAgY0hSTQAAeiUAAICDAAD5/wAAgOkAAHUwAADqYAAAOpgAABdvkl/FRgAAD69JREFUeNrs3X1QVPUex/HvWSBYwN2NlgBZ1F2VFeVhTUcE8bFLA+ooPlUyPqDj1Tuj2R2zLJs7c6fs3utDdTWZW907ZtlojTe1RqPJSq01hcFaBaW1BItVNFbdQzy4V437h5FkCAvu7vn9fufz+k9k6uzZ8/b8fudRis3b2EoAEHQarAIAxAeA+AAA8QEgPgBAfACIDwAQHwDiAwDEB4D4AADxASA+AMQHAIgPAPEBAOIDQHwAgPgAEB8AID4AxAcAiA8A8QEA4gNAfACIDwAQHwDiAwDEB4D4AADxASA+AEB8AIgPAHwRKvoHjNFpHYPN98lGfeRv3j3/retyaJ27KfpyQ4sNm0EAN7AQjSvBGH1umDW+5fa/+9xRa7jyU4u5tZX0iE8AkkTyYLOxYsHk9LB5+amZRNRlXG+VVJa+sffEtVM17jS1bgj+/gdv0dSMxhnjkvuZextMRGTq7PfLq+qcr+85Xrf38HcDrt/42aSW9STF5m1sFSW6qaOTv1732PihhujwHgXkafTKT71y4Ov3vzg9FBF23xCL0b7l2YltwfXIhu1l9pe2l/VTQ4RCxJcUpyv9dPPsQT2NrqMIF67Z57Afd41FUr7t6UpenmW8m+hut6r44KGt+07YRP5HkOv4JInk9Y9N+OaX4aXflVfVOWeu3kPNV69ZkVjH679oUrpj7dJxY7H+VRRfaIjG9cH6GU3DUxIC+sV4Gr3ytFXvVZysducgt1siI8Kc//1bAQVj/T+4bMc3tRcbMkVbhxpev/hT7/yxV6C/eCIiQ3S4/kBxYc6CyemHkNytYb5j28L4YK3/Y1uLModYjHbEx8BQx7FtYby/5ne+Wrt03Nin5o60qz28IRaj/djWosxgr/8DxYU5SXG6UsSnYHj7Xpx1IdhffJuVhSNy1BzgEIvRfqC4ULHh96ebZw+KjAhzIj4FPDlnZEUwhjoIkL3wbk0BZkdJEskirNOQqAH5f+VlnvHmXyZls7As2WmJfSSNZD98wtUH4QXXvb0idHExUcc/Lq3h/jwgF3s+SSL5082zB7G0TCsLR+TkZJiEPwgTGRHm3L12RhpLyzQvPzUzRqd1IL4gKJqU7lBqnteZXf+YPlbEo3Dtw1Pi4JYvSl6eZUR8ARYaonEF6iSuPxwoLswRMUCWwyMiMvc2mHhf78zHt6JwxFnWl1G0AFkPr82WZyf2Q3wBnOstmpKRxsOKFCVAXsJr2/vxfO6P6fgGm40VPGwE7QN8au5IO6+HwnMyTId4Ca/N448M5/YfOqav7dywfEJpoC6aDqSa8x7Xwhc+PHu314OGhmhcuqhwd2e/c/V/17V3e+FxjE7r+OefH6S8LIuNx404buImmce7H5iNT5JIvvjhcq5vJ6k573G9uttxpuzU+ZA6d1N0288TjFGNA00x14mIkvvGhKaajdFERNa+MXd9W46n0SsfrThX0/bnXQdPe4iI3HKzdKrm0q/rM0ob5h1mjW9ZXJCRoPSFC3drWNHWUh4vvGY2vqQ4XemxrUXCXckO/req+OChN/ae4O7eS2bnfB098wOgI+Mf6MPlCInZ+HJsJi02K/AFr3NVZuO73xAZjs0KRMZsfCPTEs34esBXPF7ryWx8PJ1rAhAqPgDEpxBPo1fG1wOITwHtTxQDdIXHx/4zG9+PnmYvNinAnk8BdocLJ9nBJx8dqXYgPj/63FFrwGYFvjjw1Q8y4vPzGB4HXcAX735SFY/4/Ow/HxyvwKYFnak573Hx+i4HpuPbvPNYLDYv6Mzf3zz6Ha/LznR8zVevWd8qqSzFJgYd8TR65fe/OD0U8QXI08UHE7GZQUemrXqvguf39zEf3/UbP5umP70LbwiC3/joSLWD99e2cXFtp/24a+yG7WV2bHJAdPMgy/zn93J/1ws3F1avf/toWnlVnRObHuZ545fuaBLhddHcxNfaSvpJT+yM5/VqBvBPeLa5Wy6I8pporm4pam0l/bzn9towBFWf8qo6p/Xh14R6Pzs3rwhr7/AJVx9JI9mz0xL7YLNUR3iTntgZL8JQk9s93+1zwJrzHhc2TfHNXL2HRAuP6/haW0k/c/Wec9g0xbZhe5ldpKGmEPEREdVebMjExddiE/kSQ+6f4YI73sUm6l5PiPja3kUA4hH9vC738d2ri5CwmYrpPr02CvExjNfn9EPX7vaNTawL5f0DWPvGGHlefrnJSyfPuElu8lJldf3NnzV66WS1u1v/naS4XpQUpyMiolRLLOmjwn/zM15FRoQ5RZ33cR1faIjGxdO/jpXV9VR5xk2V1fV0stpNh08E5zTlqHQTJcX1olRLLKVaYik7nZ+7tMy99fUnq92Ij8G93lkiYjq+kiPVVHLkDJV8WU1ykzJPQ7wVedWvP8vPslB+Vn/Kz7aQPordd9IsmJwetnLTZ0IOO5l+LXRXWH1ttNzkpfVvl9K7+6sUC647Hs1NocUFNkq1sHdKzdPolZNnvSbkvJ7bAy6SRDKL4VVW19Pw+Vvp9T0OLsIjInpnfxVNWLqD3tlfxdyyGaLD9UlxulLEx5DBZiOTTzab/9w+bqK73fKX9lPtxQbmluvxR4YT4mPI+mXjmRsjfXniHJMbb7f2gp+wt/ebl5+aKUkkIz4GREaEOYenJAh72RH83qh0kwPxMWDZrGH1LC5Xdnoi00cOfcHiQRcioheXT+iP+BQmSSQvmpKRxury5WdbuN0YkuJ0lJ/F5vKbextMPL76Waj4BpuNFSy/Mvr5JWO43fu9siKX6eVbXZTlRXwK2vLsxH4sL58+Kpw2PZHL3YawuMDG/JUv8/JTM0NDNC7Ep4AYndbBw+Vk+VkWWlxg42qet2bJGC6WdW5+6hnEh2FHp9YsGUOP5qZwEd7uddO52QaemZ9lE+W0AzfxhYZoXCxe0dKZTStymQ5QHxVOu9dN52qOaogO17N6gYWw8fE63GA1wLY9Ho8Hh1if9wsVnySR/Mz8LBuvK5m1ANvCY/WcXldEOe3ARXysn17wNUAWDsKMSjdxu8fjdf7PdXyiDDPWLBlDmxQ8l/ZobgrtXst/eERinHZgPj5eTi90J4DPimcHPYBNK3IVDT8QJo8a8B3iC6BFUzMaSTCpllgqf7MoKHMufVQ4fVY8m4vTHt217rHxQxFfgISGaFwrC0fkkICCEUUwI1eCITpcP8RitCM+DCuYGg4qNbwNtlVzRkYjvgB4Zv7IAaQC/g5F6QM7wZSXZbHxeuCF2fiS4nSloj809fYhoj9OAbBySiOYVhSOOIv4/EjU53YEMkDWL2cLFJbv7+QuPh6v4/RngE/O6f5HH5VuUmV4RPweeGEyPjUcaOnM4gJbtx/zvmnFH9S8yrg88MJkfGo50NKZ7jzOISlOx/07Ge4WjwdemItPtCtaempUuqkbv5tIwN+dL8zFJ+IVLT2RFNerW3s+IPrTNFt/xNdDrD+ZLJi6c1XKqDQTVhjdvNWIp0fLMxWfCLcO+Xfv59seTRd9D1bWL2Y/NPga4uuBBZPTw7D53NLHx/hEvXazR9OWKRlpvDzjhZn41Hxu7457tCjs0bqLp2e8MBPfyNTeZ7Dp3LZH69/1Hq07R0XVgpcRFDPxrZ6fFY/NBvyBl7caMRFfaIjGhbcO9Wwu151TEmrCw9CTifgw5OyYLxdY4xxfx1h8fyOT8WHI2TGcQui54SkJVtYvN1M8Pgw5727YidMM/I6oNFhB4g9N1WrxVJse8WHI2WOY0/VcXpaF6ZeqKBofhpxd6+oql2zc0dAplo96KhofhpwQaCyfcFc0PtbH5CwYYjHe8e9wsKVrLJ9wVyw+SSI5L8tiw+bRuYlZd75FLT/bghXkA9P9um8QHydjcZZkpyd2+GCkpDid6h4R2FOs3makWHyTRg3AVuGjTSty6ck5mb+eVlDL06j9hdUbtKXYvI2tSvyPT+9cIuPGWQiWftP+5Wy+eo2pI+uK7PlidFoHwoNgemiEuQ7DTiKaOmagjM0BgmlxQUYC4iOiWROsuKoFgmp4SoKVtVMOQY9PkkjGVS2gBNaOsGvUvgJAPVg7wq5R+woA9WDtlEPQ45sxLrkfNgNQgiE6XB8ZEeZUZXyREWFOvIcBlPSANe6CKuNj6YODOhWMTY5QZXwsfXBQpymjBw5SZXwsfXDAvE818UVGhDlxSRlg3qdAfJjvAeZ9CsWH+R5g3qdQfJjvAeZ9CsSH+R5g3qdQfObe+np83YB5nwLx4XpOYM3oDFOiKuLD9ZzAGnNvg0npF6kEPD5JIhnXcwKLrH1jzgodH6vPTAQYMbj3DaHjG2aNb8HXDCwa/0AfvdDxTR+XbMDXDCxS+onpAY9vZFqiGV8zsCpGp3UIGx9OrgPLorRhXiHjY+mWfYCOKHlMIqDxRdwTioMtAErEd+WnFsz3gGluuVkSMr7WVsJ8D5h2quaSXsj4iIjKq+ow7wNmNTR5jcLGd/DrWtzRAEyqOe9xXb/xs0nY+HZ8fCoMXzOw6NXdjjNK/v8DHl/txYbMmvMeF75qYM22ksr+QsdHRLTwhQ/P4qsGlmzYXmZXcsgZtPhOVrtzcOAFWPLS9rJ+Si9D0B6gNHP1HnzjwITpT+86pPReL6jxNV+9Zh2/dLsdXz0oPdy0H3eNZWFZgvq4+JPV7hwECEqGt27b0RxWlifo7+c7We3OGVa0tdTT6JWxOUCwLP77RwdZCk+R+Ihunn6wPvwabdhehr0gBFR5VZ1z0CP/duz5/PQ41pZNis3b2KrkAkRGhDmXzRpWv2hKRhru/QN/eauksnTju+VUe7Ehk9VlVDy+9mJ0WscYW5Inx2bSjs4wJeKpZ+ALT6NXPlpxrmbXwdOeY84LWtePDYN4uKifqfh+t3ASyff20tYgSLhTaJfkFkPz1WtWHj8L0/F1todMMEY1DjTFXJ8+LtlgNGi1w1MSrNg0xYvswFc/yN/WXqZTNZf0V35qMYt0mxqX8XU2f4y4J7RljC3JQ3TzyWkIk1015z0u5/eX3ZU17sbT31++fsx5QdvUci38ckOLTQ2fX6j4fNljEhG1xZncNyY01WyMJlL+MXKiKa+qc7o9LS0/epq9doerhYioLa6GJq+RhStMEB+j80yim0+2av+AnRybSXu/ITK87c9qCbYtpLY/H/jqB/lKw9VWIqJvXZdD69xN0UQ3b0xFVIhP8XDbuz3iztweeHftOnja48vvtY+mPQSE+ACEp8EqAEB8AIgPABAfAOIDAMQHgPgAAPEBID4AQHwAiA8AEB8A4gNAfACA+AAQHwAgPgDEBwCIDwDxAQDiA0B8AID4ABAfACA+AMQHgPgAAPEBID4AQHwAiA8AEB8A4gMAxAeA+AAA8QEgPgBAfACID0Dd/j8AIwkTfS6OLVMAAAAASUVORK5CYII=';
      var gemsvnLogo = 'data:image/png;base64,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'
      content = content.concat(
          [
            {
              columns: [
                {
                  image: gauLogo,
                  width: 60,
                },
                {
                  width: '*',
                  text: [
                    {text: 'GẤU UNIFORM \n', style: 'titleLogo'},
                    {
                      text: 'Thương hiệu số 1 về giải pháp thiết kế, mẫu mã và triển khai sản xuất\n áo thun cho Học sinh - Sinh viên và Doanh nghiệp tại Việt Nam \n',
                      style: 'footer'
                    },
                    {text: 'VP Hà Nôi: Tầng 4 - Số 3/120 - Trường Chinh - Đống Đa - Hà Nội \n', style: 'footer'},
                    {text: 'VP HCM: Tầng 8 - Số 17 Hồ Bá Kiện - P.15 - Quận 10 - TP.HCM \n', style: 'footer'},
                  ]
                },
                {
                  image: gemsvnLogo,
                  width: 60,
                }
              ],
              // optional space between columns
              columnGap: 10
            },

            {
              text: '\nTHÔNG TIN SHIP HÀNG',
              style: 'header',
              alignment: 'center'
            },

            {
              text: this.generateContent(item)
            },

            // {text: 'Ảnh minh họa \n', pageOrientation: 'landscape', pageBreak: 'before'}
          ]
      );

      content = content.concat(this.generateColumnData(item));
      content = content.concat(this.generateGifts(item));

      content = content.concat(images);
      var docDefinition = {
        // footer: {
        //     text: 'Thương hiệu số 1 về giải pháp thiết kế, mẫu mã và triển khai sản xuất áo thun cho Học sinh - Sinh viên và Doanh nghiệp tại Việt Nam',
        //     style: 'footer',
        //     alignment: 'center'
        // },
        // footer: function(currentPage) { return {
        //         text: currentPage.toString(),
        //         style: 'footer',
        //         alignment: 'right',
        //         margin: [5, 5]
        //     }},
        info: {
          title: item.code,
          author: 'GauUniform',
          subject: '',
          keywords: '',
        },
        content: content,
        pageSize: 'A5',

        // by default we use portrait, you can change it to landscape if you wish
        pageOrientation: 'landscape',

        // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
        pageMargins: [20, 20, 20, 20],

        styles: {
          title: {
            fontSize: 14,
            bold: true
          },
          address: {
            fontSize: 9
          },
          header: {
            fontSize: 15,
            bold: true
          },
          titleLogo: {
            fontSize: 13,
            bold: true
          },
          content: {
            fontSize: 11
          },
          subtitle: {
            fontSize: 12,
            bold: true
          },
          footer: {
            fontSize: 9,
            italics: true
          },
          money: {
            fontSize: 13,
            bold: true
          }
        }
      };


      pdfMake.createPdf(docDefinition).open();
    },

    async generateImageContent(item) {
      var contentImage = [];
      var requestDetails = item.request_details;
      const self = this;
      for (const element of requestDetails) {
        var files = element.files;
        for (const file of files) {
          const image = await this.getBase64ImageFromURL(self.baseAttach + file._id + '/0/500')
          contentImage.push(
              {
                image: image,
                width: 380,
                alignment: 'center',
                margin: [0, 20],
                pageOrientation: 'portrait', pageBreak: 'before'
              }
          )
        }
      }

      return contentImage;
    },

    generateContent(item) {
      var content = [];
      const customer = item.customer;
      // const designRequest = item.designRequest;
      content = [].concat(
          [
            // {text: '\nThông tin khách hàng \n', style: 'subtitle'},
            // {text: 'Họ tên: ' + customer.fullname + '\n', style: 'content'},
            // {text: 'Số điện thoại: ' + (customer.phone ? customer.phone : '') + '\n', style: 'content'},
            // {text: 'Facebook: ' + (customer.facebook ? customer.facebook : '')+ '\n \n', style: 'content'},
            {text: '\nThông tin giao hàng \n', style: 'subtitle'},
            {text: 'Người nhận: ' + customer.defaultAddress.name + '.\n', style: 'content'},
            {
              text: 'Số điện thoại: ' + (customer.defaultAddress.phone ? customer.defaultAddress.phone : '') + '.\n',
              style: 'content'
            },
            {
              text: 'Địa chỉ giao hàng: ' + (customer.defaultAddress.fullDetail ? customer.defaultAddress.fullDetail : '') + '.\n \n',
              style: 'content'
            },
          ]
      )

      return content
    },

    generateColumnData(item) {
      const designRequest = item.designRequest;

      const data = {
        columns: [
          {
            text: [
              {text: 'Thông tin sản phẩm \n', style: 'subtitle'},
              {text: 'Tên đơn hàng: ' + this.$getManufactureRequestTitle(item) + '.\n', style: 'content'},
              {
                text: [
                  {text: 'Mã thiết kế: ', style: 'content'},
                  {text: (designRequest ? designRequest.code : 'Không có')+ '.\n', style: 'subtitle'}
                ]
              },
              {
                text: [
                  {text: 'Mã sản xuất: ', style: 'content'},
                  {text: item.code + '.\n', style: 'subtitle'}
                ]
              },
              {
                text: [
                  {text: 'Số lượng áo: ', style: 'content'},
                  {text: this.thousandSeprator(this.calculateTotalSizeOfAll(item)), style: 'money'},
                  {text: ' chiếc. \n \n', style: 'content'}
                ]
              },

              {text: 'Thông tin tài chính \n', style: 'subtitle'},
              {
                text: [
                  {text: 'Số tiền cần thu: ', style: 'content'},
                  {
                    text: this.thousandSeprator(item.totalEdit ? item.totalEdit : this.calculateMoneyHasToPay(item)),
                    style: 'money'
                  },
                  {text: ' đ.\n', style: 'content'}
                ]
              },
              {
                text: 'Phương án thu tiền: ' + this.generateTextByPaymentMethod(item.paymentMethod) + '.\n \n',
                style: 'content'
              },
            ]
          },
          {
            text: [
              {text: 'Ghi chú \n', style: 'subtitle'},
              {
                text: 'Ghi chú vận chuyển: ' + (item.shipNote ? item.shipNote : 'Không có') + '.\n',
                style: 'content'
              },
              {
                text: 'Ghi chú quà tặng: ' + (item.giftNote ? item.giftNote : 'Không có') + '.\n \n',
                style: 'content'
              }
            ]
          }
        ],
        columnGap: 10,
        width: '50%',
      }

      return data;
    },

    generateGifts(item) {
      var content = [];
      content.push({text: 'Thông tin quà tặng \n', style: 'subtitle'})

      item.gifts.forEach((gift, index) => {
        var giftText = {text: (index + 1) + '. ' + gift.name + '.', style: 'content'}
        content.push(giftText);
      });

      return content;
    },

    calculateMoneyHasToPay(editedItem) {
      const prepay = editedItem.prepay ? editedItem.prepay : 0;
      return editedItem.total - prepay;
    },

    thousandSeprator(amount) {
      if (amount && (amount !== '' || amount !== 0 || amount !== '0')) {
        return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else {
        return 0;
      }
    },

    getBase64ImageFromURL(url) {
      return new Promise((resolve, reject) => {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
          var canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;

          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          var dataURL = canvas.toDataURL("image/png");

          resolve(dataURL);
        };

        img.onerror = error => {
          reject(error);
        };

        img.src = url;
      });
    },

    calculateTotalSizeOfAll(detail) {
      let total = 0;
      if (detail.request_details) {
        detail.request_details.forEach(detail => {
          total = total + this.calculateTotalSizeOfProduct(detail);
        });
      }

      return total;
    },

    calculateTotalSizeOfProduct(detail) {
      let total = 0;
      detail.profilesInfo.forEach(item => {
        total = total + this.calculateProfile(item.sizes);
      });

      return total;
    },

    calculateProfile(sizes) {
      let total = 0;
      sizes.forEach(size => {
        if (!size.number) {
          size.number = 0;
        } else {
          total = total + parseInt(size.number, 10);
        }
      });

      return total;
    },

    generateTextByPaymentMethod(value) {
      if (value == 2) {
        return 'Sale tự thu tiền';
      } else {
        return 'Thu tiền qua hệ thống ship';
      }
    }

  }
}
</script>

<style scoped>
.linkText {
  color: #F08942
}

.small-button {
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  color: #F08942;
}

.nowrap-overflow {
  flex-wrap: nowrap;
  overflow-x: auto;
}
</style>